import {
  DescontoCardContainer,
  DescontoCardImage,
  DescontoContent,
  DescontoDescricao,
  DescontoEndereco,
  DescontoNome,
  DescontoTag,
} from "./styles";
import { withImageFallback } from "../../utils/imageFallback";

interface IDescontoCardProps {
  nome: string;
  endereco: string;
  desconto: string;
  descricao: string;
  imagem: string;
}

export const DescontoCard = ({
  desconto,
  endereco,
  imagem,
  nome,
  descricao,
}: IDescontoCardProps) => {
  return (
    <DescontoCardContainer>
      <DescontoCardImage src={withImageFallback(imagem)} />
      <DescontoContent>
        <DescontoNome>{nome}</DescontoNome>
        <DescontoEndereco>{endereco}</DescontoEndereco>
        {desconto && <DescontoTag>{desconto}</DescontoTag>}
        <DescontoDescricao>{descricao}</DescontoDescricao>
      </DescontoContent>
    </DescontoCardContainer>
  );
};
